<template>
    <div class="af" >
        <el-form class="table" v-loading="loading" :model="formData" :rules="formRules" ref="formRef" size="mini">
            <div class="flex borb marT10">
                <el-form-item class="form-title num flex" prop="num" label="No:" >
                    <span  style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.i_id!=0?formData.i_id:'000000'}}</span>
                </el-form-item>
<!--                <el-form-item class="form-title flex" prop="isRelPurchase" :label="$t('purchaseOrder_is_it_associated_with_procurement')" >-->
<!--                    <span   style="display: inline-block;width: 100%">{{formData.isRelPurchase==1?$t('form_correct'):$t('form_deny')}}</span>-->
<!--                </el-form-item>-->
<!--                <el-form-item class="form-title flex" v-if="formData.isRelPurchase==1" prop="relRecvCompany" :label="$t('purchaseOrder_associated_receiving_company')" :required="formData.isRelPurchase==1">-->
<!--                    <span   style="display: inline-block;width: 100%">{{formData.relRecvName}}</span>-->
<!--                </el-form-item>-->
<!--            </div>-->
<!--            <div class="flex borb marT10">-->

                <el-form-item v-if="i_id!=0&&formData.dt_expiretime" class="form-title flex" prop="dt_expiretime" :label="$t('purchaseOrder_expiration_time')" >
                    <span  style="display: inline-block;width: 100%">{{formData.dt_expiretime}}</span>
                </el-form-item>
                <el-form-item v-if="i_id!=0&&formData.dt_expiretime" class="form-title flex" prop="gsname" :label="$t('purchaseOrder_count_down')" >
                    <count-down v-if="endTimestamp" :end-time="endTimestamp" @end="handleCountdownEnd"></count-down>
                    <span v-else  style="display: inline-block;width: 100%">{{$t('purchaseOrder_expired')}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="vc_ingsname" :label="$t('purchaseOrder_ordering_company')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_ingsname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_ingname" :label="$t('purchaseOrder_order_department')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_ingname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_squname" :label="$t('form_drawer')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_squname}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="vc_khname" :label="$t('purchaseOrder_supplier')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_khname}}</span>
                </el-form-item>
                <el-form-item class="form-title flex guding" prop="dt_yjdhtime" :label="$t('purchaseOrder_expected_delivery_time')" >
                    <el-date-picker
                            size="mini"
                            v-model="formData.dt_yjdhtime"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            class="flex  wid100"
                            :placeholder="$t('purchaseOrder_expected_delivery_time')"
                            :disabled="isedit">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_inckname" :label="$t('purchaseOrder_warehousing_warehouse')" >
                    <el-select class="nodata wid100" v-model="formData.vc_inckname" :placeholder="$t('form_please_select')" @change="chooseck" filterable required clearable :disabled="isedit">
                        <el-option
                                v-for="one in ckData"
                                :key="one.i_id"
                                :label="one.vc_name"
                                :value="one.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="flex borb" v-if="formData.istran==1">
                <el-form-item class="form-title flex" prop="vc_start_add" :label="$t('purchaseOrder_pickup_address')" >
                    <el-select class="nodata wid100" v-model="formData.vc_start_add" :placeholder="$t('form_please_select')"  @change="chooseckaddr($event,'kh')" filterable required clearable :disabled="isedit">
                        <el-option
                                v-for="one in khaddrData"
                                :key="one.id"
                                :label="one.destinationAddress"
                                :value="one.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_start_lxr" :label="$t('purchaseOrder_contact')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_start_lxr}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_start_lxr_tel" :label="$t('purchaseOrder_contact_phone_number')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_start_lxr_tel}}</span>
                </el-form-item>
            </div>
            <div class="flex borb">
                <el-form-item class="form-title flex" prop="vc_shdd" :label="$t('purchaseOrder_receiving_address')" >
                    <el-select class="nodata wid100" v-model="formData.vc_shdd" :placeholder="$t('form_please_select')" @change="chooseckaddr($event,'ck')" filterable required clearable :disabled="isedit">
                        <el-option
                                v-for="one in ckaddrData"
                                :key="one.id"
                                :label="one.destinationAddress"
                                :value="one.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_sendadd_lxr" :label="$t('purchaseOrder_contact')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_sendadd_lxr}}</span>
                </el-form-item>
                <el-form-item class="form-title flex" prop="vc_sendadd_lxr_tel" :label="$t('purchaseOrder_contact_phone_number')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_sendadd_lxr_tel}}</span>
                </el-form-item>
            </div>
            <div style="margin:3px 0 10px 0">
                <el-table class="table"
                          v-if="showTable"
                          border
                          ref="multipleTable"
                          :data="pzlist"
                          height="255"
                          size="mini"
                          :row-class-name="tableRowClassName"
                          tooltip-effect="dark">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="center"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="pm"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="i_ischeck"
                            :label="$t('form_do_you_want_to_test_it')"
                            width="80"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>{{scope.row.i_ischeck==1?$t('form_correct'):$t('form_deny')}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="i_ismustcheck"
                            :label="$t('purchaseOrder_is_it_necessary_to_inspect_unloading')"
                            width="100"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>{{scope.row.i_ismustcheck==1?$t('form_correct'):$t('form_deny')}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="f_num"
                            :label="$t('purchaseOrder_apply_for_inventory_quantity')"
                            width="150">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="pzlist.f_num" >
                                <el-input-number  :disabled="isedit||formData.isRelPurchase==1" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_num" @change="numinput(pzlist,scope.$index,scope.row)"></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <!--<el-table-column
                            align="center"
                            prop="vc_pcno"
                            label="入库批次号"
                            width="150">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="pzlist.vc_pcno" >
                                <el-input  :disabled="isedit" :controls="false"  class="changeinput" size="mini" v-model="scope.row.vc_pcno" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>-->
                    <el-table-column
                            align="center"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="50"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="vc_no"
                            :label="$t('form_serial_number')"
                            width="170"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="f_yfee_yj"
                            :label="$t('saleOrder_estimated_shipping_cost')"
                            width="150"
                            v-if="formData.istran==1">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="pzlist.f_yfee_yj" >
                                <el-input-number :disabled="isedit" :controls="false" :min="0" :precision="5" class="changeinput" size="mini" v-model="scope.row.f_yfee_yj" ></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="center"  width="50"  v-if="!isedit">
                       <!-- <template slot="header" slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="1000"
                                    trigger="manual"
                                    v-model="visible">
                                <template>
                                    <product-details v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></product-details>
                                </template>
                                <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </el-popover>
                        </template>-->
                        <template  slot-scope="scope">
                            <div class="iconminus">
                                <span class="minus" v-show="!isedit&&formData.isRelPurchase!==1" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center"  width="100" :label="$t('form_operate')"  v-if="formData.i_ischeck==1&&isedit">
                        <template  slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="500"
                                    trigger="manual"
                                    v-model="scope.row.visible">
                                <div class="flex b wid100" v-if="scope.row.visible==true">
                                    <div class="flex w100-" >
                                        <div class="w40  tsc">{{$t('purchaseOrder_warehouse_batch_number')}}</div>
                                        <div class="w20  tsc">{{$t('purchaseOrder_test_results')}}</div>
                                        <div class="flex w40">
                                            <div class=" tsc">{{$t('form_attachment')}}</div>
                                        </div>
                                    </div>
                                    <div  @click="closePop(scope.row,scope.$index)"><i class="btn el-icon-close"></i></div>
                                </div>
                                <div class="wid100" v-if="scope.row.visible==true">
                                    <div class="flex w100- bor mart3" v-for="(item,index) in jylist" :key="index+'a'">
                                        <div class="w40 tsc">{{item.vc_pcno}}</div>
                                        <div class="w20 tsc">{{item.stateTxt}}</div>
                                        <div class="w40" v-for="(filsitem,filsindex) in item.vc_files.otherfiles" :key="filsindex+'b'">
                                                <a
                                                        class="tsc"
                                                        :download="filsitem.vc_name"
                                                        mce_href="#"
                                                        :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+filsitem.vc_newname+(filsitem.vc_app?(','+filsitem.vc_app):'')+'\'}','utf-8')">
                                                {{filsitem.vc_name}}
                                                </a>
                                        </div>
                                    </div>
                                </div>
                            </el-popover>
                            <el-button type="text" size="small" @click="hyClick(scope.row,scope.$index)">{{$t('purchaseOrder_test_results')}}</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <div class="flex mar3">
                <!--化验-->
                <!--<el-form-item class="form-title" prop="gsname" label="是否需要化验" >
                    <template >
                        <el-radio-group v-model="formData.i_ischeck" :disabled="isedit">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">{{$t('form_deny')}}</el-radio>
                        </el-radio-group>
                    </template>
                </el-form-item>-->
                <el-form-item class="wid66" prop="gsname" :label="$t('purchaseOrder_whether_to_arrange_transportation')" >
                    <template >
                        <el-radio-group v-model="formData.istran" @change="chooseys" :disabled="disys">
                            <el-radio :label="1">{{$t('form_correct')}}</el-radio>
                            <el-radio :label="0">{{$t('form_deny')}}</el-radio>
                        </el-radio-group>
                    </template>
                </el-form-item>
                <el-form-item v-if="formData.istran==1" class="wid66" prop="gsname" :label="$t('purchaseOrder_logistics_specialist')" >
                    <el-select  v-model="formData.vc_wluname" :placeholder="$t('form_please_select')" @change="chooseper" filterable required clearable :disabled="isedit">
                        <el-option
                                v-for="one in ysper"
                                :key="one.i_id"
                                :label="one.vc_name"
                                :value="one.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item class="wid100_bz flex" prop="vc_note" :label="$t('form_notes')" >
                <el-input class="wid100"  v-model="formData.vc_note">
                </el-input>
            </el-form-item>
            <div class="flex">
                <el-form-item class="wid50 flex" prop="vc_lruname" :label="$t('form_input_person')" >
                    <el-input class="wid100"  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="wid50 flex" prop="date" :label="$t('form_date')" >
                    <el-input  class="wid100" v-model="formData.dt_createtime" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm" :disabled="disabled" class="btn" size="small">{{$t('button_save')}}</el-button>
            <el-button type="primary"  @click="toApprove" :disabled="disabledsp" :class="disabledsp?'btn':'redbtn'" size="small">{{$t('button_submit_for_approval')}}</el-button>
            <!--<el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>-->
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {file_url} from "@/utils/baseUrl";
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    import ProductDetails from "./ProductDetails";
    import countDown from "./countDown";
    export default {
        name: "addOrder",
        components: {
            ProductDetails,countDown
        },
        props:{
            application_sq:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                endTimestamp:null,//时间戳
                sqEffectivedays:null,//申请有效天数
                typeid:0,
                jyfiles:{},
                file_url: "",
                bsaeApp:"",
                baseVersion:"",
                token:"",
                i_uid:"",
                jylist:[],
                vc_no:"",
                disabledsp:false,
                ysper:[],
                khaddrData:[],
                i_isforeign:0,
                loading:false,
                i_id:0,
                //验证
                //i_id:this.i_id,
                busType:"",
                dt_createtime:"",
                c_type:4,
                i_sqlruid:"",
                table:"",
                validateCode:"",
                validateKeynames:"",

                ckaddrData:[],
                i_ckid:0,
                ckData:[],
                i_htid:0,
                gkData:[],
                kzData:[],
                isbtn:false,
                isedit:false,
                disys:true,
                i_type:104,
                formData:{
                    i_ischeck:0,
                    istran:0,
                    dt_yjdhtime:'',
                },
                pzlist:[],
                i_issq:'1',
                i_kpnumtype:"0",
                /******************************/
                gsname:"",
                bmname:"",
                sqName:"",
                ckname:"",
                groupid:0,
                /* formData:{
                     gsname:"",
                     bmname:"",
                     sqName:"",
                     ckname:"",
                     num:"000000",
                     vc_note:"",
                     kysl:"",
                     vc_lruname:"",
                     date:"",
                     tableData:[]
                 },*/
                formRules:{
                    //f_num:[{required:true,message:"请填写出库量",trigger:"blur"},],
                },
                companyName:[],
                groupName:[],
                personName:[],
                warehouseName:[],
                tableData:[],
                f_num:"",
                visible:false,
                productDetails:{},
                vc_note:"",
                date:"",
                disabled:false,

                edit:false,
                data:{},
                i_pid:0,
                state:0,
                qgsname:"",
                qckname:"",
                gsid:0,
                gid:0,
                i_rwid:0,
                ckid:0,
                squid:0,
                index:0,
                pageSize:1,
                baseerp:"",
                form:{},
                mid:0,
                showTable:true,
            }
        },
        watch: {
        },
        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            //console.log(this.file_url,this.baseApp,this.i_uid,this.token,this.baseVersion,"zzzzzzzzzzzzzzzzzzzzz");
            //this.getLssuerList();
            //this.getPortList();
            this.getWarehouseList();
            // console.log(this.application_sq,"-----------")
            let title = this.application_sq.titleID;
            if(title=="addNew"){
                let data=this.application_sq.data;
                //console.log("新增数据",data);
                this.disabledsp=true;
                this.i_id=0;
                this.formData.i_id=data.i_id;
                this.formData.vc_ingsname=data.vc_company;
                this.formData.i_ingsid=data.i_gsid;
                this.formData.vc_ingname=data.vc_bmname;
                this.formData.i_ingid=data.i_gid;
                this.formData.vc_squname=data.vc_kduname;
                this.formData.i_squid=data.i_kduid;
                this.formData.vc_khname=data.vc_gysname;
                this.formData.i_khid=data.i_gykhid;
                this.formData.dt_yjdhtime=data.dt_createtime;
                this.formData.vc_no=data.vc_no;
                this.formData.vc_sendway=data.vc_sendway;
                this.formData.istran=data.istran;
                this.formData.relRecvCompany=data.relRecvCompany;
                // this.formData.relRecvName=data.relRecvName;
                this.formData.isRelPurchase=data.isRelPurchase;

                this.istran=data.istran;
                if(this.formData.istran==1){
                    this.getTranUserlist();
                }
                /*if(this.formData.vc_sendway=='送货'){
                    this.formData.istran=0;
                }else{
                    this.formData.istran=1;
                    this.getTranUserlist();
                }*/
                this.vc_no=data.vc_no;
                //console.log("this.i_isforeign",this.i_isforeign)
                //console.log("this.formData.istran",this.formData.istran)
                this.i_isforeign=data.i_isforeign;
                this.disys=data.i_isforeign==1?false:true;
                this.formData.i_kpnumtype=data.i_kpnumtype;
                this.formData.vc_lruname=sessionStorage.getItem("lruname");
                this.getDateYYYYMMddHHMMSS();
                this.ckAddressList('kh');
                this.pickList();
            }else{
                this.i_id=this.application_sq.i_id;
                //console.log("编辑id",this.i_id,this.application_sq);
                this.vc_no=this.application_sq.vc_no;
                //this.i_isforeign=this.application_sq.i_isforeign;
                //this.disys=this.application_sq.i_isforeign==1?false:true;
                this.isedit=true;
                this.isbtn=true;
                this.sqdetail();

            }

        },
        methods:{
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            closePop(row,index){
                this.pzlist[index].visible=false;
                //this.visible=false;
               // this.isbtn=false;
            },
            //化验单列表 checkResult
            async checkResult(row,index){
                let param={
                    i_id:this.i_id,
                    i_pzid:row.i_pzid,
                    vc_no:row.vc_no,
                };
                let res=await API.checkResult(param);
                if(res.code==1){
                    //console.log("res.data",res.data)
                    this.jylist=res.data;
                    this.jyfiles=res.data.vc_files;
                    this.pzlist[index].visible=true;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            hyClick(row,index){
                //console.log("??????",row);
                this.checkResult(row,index);
                /*this.jylist=[
                    {
                        vc_pcno:"CH-202312080001",
                        stateTxt:"合格",
                        i_state:1,
                        vc_files: {
                            otherfiles:[
                                {
                                    vc_name:"123456789.png",
                                    vc_newname:"123456789",
                                }
                            ]
                        },
                    },
                    {
                        vc_pcno:"CH-202312080001",
                        stateTxt:"合格",
                        i_state:1,
                        vc_files: {
                            otherfiles:[
                                {
                                    vc_name:"123456789.png",
                                    vc_newname:"123456789",
                                }
                            ]
                        },
                    }
                ];
                this.pzlist[index].visible=true;*/
                //this.visible=true;
            },
            chooseper(e){
                let choo = this.ysper.filter((item,index)=>{
                    return item.i_id == e
                })
                //console.log("choo",choo);
                if(choo.length!=0){
                    this.formData.i_wluid=choo[0].i_id;
                    this.formData.vc_wluname=choo[0].vc_name;
                }else{
                    this.formData.i_wluid=0;
                    this.formData.vc_wluname="";
                }
            },
            chooseys(e){
              //console.log("e",e)
              this.formData.istran=e;
              if(e==1){
                  this.getTranUserlist();
              }
            },

            //获取运输专员
            async getTranUserlist(){
                let param={};
                let res=await API.getTranUserlist(param);
                if(res.code==1){
                    this.ysper=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },

            //获取品种列表
            async pickList(){
                let param={
                    i_id:this.formData.i_id,
                    i_gsid: this.formData.i_ingsid,
                    i_ckid: this.formData.i_inckid,
                    i_gis: this.formData.i_ingid,
                    pageSize:99,
                    currentPage:1,
                    c_type:4,
                };
                let res=await API.pickList(param);
                if(res.code==1){
                    this.formData.i_pid=res.data.list.length>0?res.data.list[0].i_pid:0;//出入库申请主子表ID
                    for(let i=0;i<res.data.list.length;i++){
                        res.data.list[i].f_num=res.data.list[i].kysl;
                        res.data.list[i].i_ywid=res.data.list[i].i_id;
                    }
                    this.pzlist=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            chooseckaddr(e,type){
                //console.log("type",type,e,"e")
                if(type=="ck"){
                    //this.typeid = 10274;
                    let choo = this.ckaddrData.filter((item,index)=>{
                        return item.id == e
                    })
                    //console.log("choo",choo);
                    if(choo.length!=0){
                        //console.log("------------")
                        this.formData.vc_shdd=choo[0].destinationAddress;
                        this.formData.vc_sendadd_lxr=choo[0].destinationLxr;
                        this.formData.vc_sendadd_lxr_tel=choo[0].destinationPhone;
                    }else{
                        this.formData.vc_shdd='';
                        this.formData.vc_sendadd_lxr='';
                        this.formData.vc_sendadd_lxr_tel='';
                    }
                }
                if(type=="kh"){
                    //this.typeid = 10275;
                    let choo = this.khaddrData.filter((item,index)=>{
                        return item.id == e
                    })
                    //console.log("choo",choo);
                    if(choo.length!=0){
                        this.formData.vc_start_add=choo[0].destinationAddress;
                        this.formData.vc_start_lxr=choo[0].destinationLxr;
                        this.formData.vc_start_lxr_tel=choo[0].destinationPhone;
                    }else{
                        this.formData.vc_start_add='';
                        this.formData.vc_start_lxr='';
                        this.formData.vc_start_lxr_tel='';
                    }
                }
                this.$nextTick(()=>{
                    this.$forceUpdate()
                })
            },
            chooseck(e){
                let choo = this.ckData.filter((item,index)=>{
                    return item.i_id == e
                })
                //console.log("choo????????",choo);
                if(choo.length!=0){
                    this.formData.i_inckid=e;
                    this.formData.vc_inckname=choo[0].vc_name;
                    this.formData.vc_shdd='';
                    this.formData.vc_sendadd_lxr='';
                    this.formData.vc_sendadd_lxr_tel='';
                    this.ckAddressList('ck');
                    //判断是否运输的禁用
                    let isstore=choo[0].isstore;
                    //console.log("this.i_isforeign",this.i_isforeign)
                    //console.log("this.formData.istran",this.formData.istran)
                    if(this.i_isforeign==0&&this.istran==1){
                        //console.log("isstore",isstore)
                        if(isstore==0){
                            this.formData.istran=0;
                            this.disys=false;
                        }else if(isstore==1||2){
                            this.formData.istran=1;
                            this.disys=true;
                        }
                    }


                }else{
                    this.formData.i_inckid="";
                    this.formData.vc_inckname="";
                }


            },
            //仓库列表
            async getWarehouseList(){

                let param={
                    page_size:1,
                    page_count:999,
                };
                let res=await API.getWarehouseList(param);
                if(res.code==1){
                    this.ckData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            //仓库地址列表
            async ckAddressList(type){
                let param={
                    ckid:type=="ck"?this.formData.i_inckid:this.formData.i_khid,
                    typeid:type=="ck"?10274:10275,
                };
                let res=await API.ckAddressList(param);
                if(res.code==1){
                    if(type=="ck"){
                        this.ckaddrData=res.data;
                    }else if(type=="kh"){
                        this.khaddrData=res.data;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },

            choosegk(e,type){
                //console.log("e",e,"type",type);
                if(type=="qs"){
                    this.formData.i_startport=e;
                    if(this.formData.i_startport==this.formData.i_endport){
                        //console.log("???")
                        this.$message.error(this.$t('purchaseOrder_the_starting_and_destination_ports_cannot_be_the_same_port'));
                        this.formData.i_startport=0;
                        this.formData.vc_startport="";
                        return ;
                    }else{
                        let choo = this.gkData.filter((item,index)=>{
                            return item.i_id == e
                        });
                        //console.log("choo",choo);
                        if(choo.length!=0){
                            this.formData.vc_startport=choo[0].vc_name;
                        }else{
                            this.formData.vc_startport="";
                            this.formData.i_startport=0;
                        }

                    }
                };
                if(type=="md"){
                    this.formData.i_endport=e;
                    if(this.formData.i_endport==this.formData.i_startport){
                        //console.log("???")
                        this.$message.error(this.$t('purchaseOrder_the_starting_and_destination_ports_cannot_be_te_same_port'));
                        this.formData.i_endport=0;
                        this.formData.vc_endport="";
                        return ;
                    }else{
                        let choo = this.gkData.filter((item,index)=>{
                            return item.i_id == e
                        });
                        //console.log("choo",choo);
                        if(choo.length!=0){
                            this.formData.vc_endport=choo[0].vc_name;
                        }else{
                            this.formData.vc_endport='';
                            this.formData.i_endport=0;
                        }

                    }
                };
            },
            //港口列表
            async getPortList(){
                let param={
                    vc_search:"",
                };
                let res=await API.getPortList(param);
                if(res.code==1){
                    this.gkData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            choosekz(e){
                //console.log("e11111111111",e)
                let choo = this.kzData.filter((item,index)=>{
                    return item.i_id == e
                })
                //console.log("choo",choo);
                if(choo.length!=0){
                    this.formData.i_kzs=choo[0].i_id;
                    this.formData.vc_kzkhname=choo[0].vc_name;
                    this.formData.f_bzj=choo[0].f_bzj;
                }else{
                    this.formData.i_kzs="";
                    this.formData.vc_kzkhname="";
                    this.formData.f_bzj=0;
                }

            },
            //开证商列表
            async getLssuerList(){
                let param={
                    vc_search:"",
                };
                let res=await API.getLssuerList(param);
                if(res.code==1){
                    this.kzData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            //获取详情
            async sqdetail(id){
                let param={
                    i_id:id?id:this.i_id,
                };
                let res=await API.sqdetail(param);
                if(res.code==1){
                    this.formData=res.data;
                    //this.formData.istran=res.data.istran.toString();
                    if(res.data.i_state==0){
                        this.disabledsp=false;
                    }else{
                        this.disabledsp=true;
                        this.disabled=true;
                    }
                    if(res.data.istran==1){
                        this.getTranUserlist();
                    }
                    this.formData.i_id=res.data.i_id;
                    this.formData.vc_ingsname=res.data.vc_ingsname;
                    this.formData.i_ingsid=res.data.i_ingsid;
                    this.formData.vc_ingname=res.data.vc_ingname;
                    this.formData.i_ingid=res.data.i_ingid;
                    this.formData.vc_inckname=res.data.vc_inckname;
                    this.formData.i_inckid=res.data.i_inckid;
                    this.formData.vc_squname=res.data.vc_squname;
                    this.formData.i_squid=res.data.i_squid;
                    this.formData.vc_khname=res.data.vc_khname;
                    this.formData.i_khid=res.data.i_khid;
                    this.formData.dt_yjdhtime=res.data.dt_yjdhtime;
                    this.formData.vc_lruname=res.data.vc_lruname;
                    this.formData.vc_sendway=res.data.vc_thfs;
                    this.formData.relRecvCompany=res.data.relRecvCompany;
                    this.formData.isRelPurchase=res.data.isRelPurchase;
                    this.formData.i_pid=res.data.i_id;//出入库申请主子表ID
                    this.pzlist=res.data.sub;
                    this.ckAddressList('ck');
                    this.ckAddressList('kh');
                    this.i_isforeign=res.data.i_isforeign;
                    this.disys=true;
                   /* return;
                    this.getAddressList();
                    this.i_kpnumtype=res.data.i_kpnumtype.toString();
                    this.i_issq=res.data.i_issq.toString();
                    this.i_isforeign=res.data.i_isforeign;
                    //console.log("this.i_issq",this.i_issq);*/
                    //验证
                    this.i_id=res.data.i_id;
                    this.busType=res.data.busType;
                    this.dt_createtime=res.data.dt_createtime;
                    this.c_type=res.data.c_type;
                    this.i_sqlruid=res.data.i_sqlruid;
                    this.table=res.data.table;
                    this.validateCode=res.data.validateCode;
                    this.validateKeynames=res.data.validateKeynames;
                    //更新倒计时
                    //let times ='2025-02-20 17:10:11';
                    let times =res.data.dt_expiretime;
                    times = (new Date(times)).getTime(); //得到时间戳
                    this.endTimestamp=times;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            handleCountdownEnd() {
                //console.log('倒计时结束')
                this.endTimestamp=null;
            },
            /****************************************/
            /* async getPickingListSc(){
                 let param={
                     i_mid:this.mid,
                     i_pid:this.i_pid,
                 };
                 let res=await API.getPickingListSc(param);
                 if(res.code==1){
                     let data=res.data;
                     this.formRules={};$
                     this.formData={
                         gsname:data.vc_outgsname,
                         bmname:data.outcjname,
                         sqName:data.vc_squname,
                         ckname:data.vc_outckname,
                         num:data.i_id,
                         vc_note:data.vc_note,
                         vc_lruname:data.vc_lruname,
                         date:data.dt_createtime,
                         tableData:data.details,
                     };
                     // this.state=data.i_state;
                     this.tableData=data.details;
                     this.gsid=data.i_outgsid;
                     this.gid=data.i_cjid;
                     this.squid=data.i_squid;
                     this.sqName=data.vc_squname;
                     this.i_lruid=data.i_lruid;
                     this.i_lruname=data.i_lruname;
                     this.ckid=data.i_outckid;
                     this.productDetails.gsid=data.i_gsid;
                     this.productDetails.i_mid=this.mid;
                     this.productDetails.ckid=data.i_ckid;
                     this.productDetails.gsid_out=data.i_gsid_out;
                     this.productDetails.i_pzid=data.i_pzid;
                     this.productDetails.i_type=data.i_type;
                     this.productDetails.selected=[];
                 }else if (res.code == -2) {
                     this.$router.push('/login');
                     this.$message.error(res.message);
                 }
                 else{
                     this.$message.error(res.message);
                 }
             },*/
            numinput(data,index,row){
                //console.log(data,'data',row,'row')
                if (row.f_num > row.kysl) {
                    this.$message.error(this.$t('purchaseOrder_the_number_of_applications_should_be_less_than_the_available_quantity'));
                    row.f_num=0 ;
                    this.$set(data,index,row);
                }
                this.refreshTable()
            },
            /*numinput(e,value,index){
                //console.log("pz",this.pzlist)
                //console.log("value",value,"e",e,"index",index)
                if (e> this.pzlist[index].kysl) {
                    //console.log("e",e )
                    //console.log("this.pzlist[index].f_num_ky",this.pzlist[index].f_num_ky )
                    this.$message.error(this.$t('purchaseOrder_the_number_of_applications_should_be_less_than_the_available_quantity'));
                    this.pzlist[index].f_num=0 ;
                    this.$forceUpdate();
                }else{
                    this.pzlist[index].f_num=e;
                    this.$forceUpdate();
                }
            },*/
            popShow(){
                this.productDetails={
                    i_id:this.i_id,
                    i_gsid: this.formData.i_ingsid,
                    i_ckid: this.formData.i_inckid,
                    i_gis: this.formData.i_ingid,
                }
                this.visible=true;
                if (this.visible==true){
                    this.isbtn=true
                }
                //console.log(this.visible)
                /*if (this.formData.gsname==''||this.formData.ckname==''){
                    this.$message.error("请选择公司或仓库")
                    return
                }else if(this.formData.gsname!=''&&this.formData.ckname!=''){
                    this.visible=true;
                }
                if (this.visible==true){
                    this.isbtn=true
                }*/
            },

            //产品列表
            transValue(value){
                /*let arr=[];
                if ( this.formData.tableData.length>0){

                }else {
                     arr=[...value];
                }*/
                let arr=[...this.pzlist,...value];
                //console.log(value,"------------")

                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_unique] ? '' : hash[next.vc_unique] = true && item.push(next);
                    return item
                }, []);
                //console.log("arr?????",arr)
                for(let i=0;i<arr.length;i++){
                    arr[i].f_num=arr[i].f_num_ky;
                    arr[i].f_je=(arr[i].f_num*arr[i].f_price).toFixed(2);
                }
                this.formData.pzlist=arr;
                this.pzlist=arr;
                this.productDetails.selected=this.pzlist;
                /*this.formData.tableData=arr;
                this.tableData=arr;
                this.productDetails.selected=this.tableData;*/
                //console.log("**arr**",newArr3)
            },
            deleteRow(value,index){
                this.pzlist.splice(index,1);
                /*this.index=index;
                this.tableData.splice(this.index,1);
                // console.log(value,"-----")*/
            },
            //提交审批
            toApprove(){
                this.flowsub()
            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close',"applic");

                //this.$emit('getPickingReqList')
            },

            //审批接口
            async flowsub(){
                this.loading=true;
                let param={
                    //验证
                    i_id:this.i_id,
                    busType:this.busType,
                    dt_createtime:this.dt_createtime,
                    c_type:this.c_type,
                    i_sqlruid:this.i_sqlruid,
                    table:this.table,
                    validateCode:this.validateCode,
                    validateKeynames:this.validateKeynames,
                };
                let res=await API.flowsub(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.loading=false;
                    this.visible=false;
                    this.$emit('shuaxinboth',this.vc_no);
                    this.cancel();
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.loading=false;
                    this.$message.error(res.message);
                }

            },


            //保存
            async saveForm(){
                //console.log("this.formData",this.formData);
                //console.log("this.pzlist",this.pzlist);
                //return;
                /* //验证
                this.formData.i_id=this.i_id;
                this.formData.busType=this.busType;
                this.formData.dt_createtime=this.dt_createtime;
                this.formData.uid=this.uid;
                this.formData.table=this.table;
                this.formData.validateCode=this.validateCode;
                this.formData.validateKeynames=this.validateKeynames;*/
                if (this.pzlist.length==0){
                    this.$message.error(this.$t('purchaseOrder_no_variety_available_for_application'));
                    return ;
                }
                let kong = this.pzlist.some((item)=>{
                    return item.f_num==0
                });
                //console.log("kong",kong);
                if(kong){
                    this.$message.error(this.$t('purchaseOrder_the_requested_inventory_quantity_cannot_be_0'));
                    return ;
                }
                if (this.formData.i_inckid==''||!this.formData.i_inckid){
                    this.$message.error(this.$t('purchaseOrder_the_warehouse_cannot_be_empty'));
                    return ;
                }

                //if(this.formData.vc_sendway!='送货'){
               if(this.formData.istran==1){
                    if (this.formData.vc_start_add==''||!this.formData.vc_start_add){
                        this.$message.error(this.$t('purchaseOrder_the_delivery_address_cannot_be_empty'));
                        return ;
                    }
                }

                if (this.formData.vc_shdd==''||!this.formData.vc_shdd){
                    this.$message.error(this.$t('purchaseOrder_the_shipping_address_cannot_be_empty'));
                    return ;
                }
                /*let kong = this.pzlist.some((item)=>{
                    return item.vc_pcno==""||!item.vc_pcno
                });
                console.log("kong",kong);
                if(kong){
                    this.$message.error("请输入入库批次号！");
                    return ;
                }*/
                /*let kongyf = this.pzlist.some((item)=>{
                    return item.f_yfee_yj==""||!item.f_yfee_yj
                });
                //console.log("kongyf",kongyf);
                if(kongyf){
                    this.$message.error("请输入预估运费！");
                    return ;
                }*/
                //console.log("this.formData.istran",this.formData.istran)
                if(this.formData.istran==1){
                    if(!this.formData.vc_wluname){
                        this.$message.error(this.$t('purchaseOrder_please_select_a_logistics_specialist'));
                        return ;
                    }
                }
                this.disabled=true;
                this.disabledsp=true;
                this.loading=true;
                let param={
                    i_id:this.i_id,
                    i_ingid:this.formData.i_ingid,
                    i_ingsid:this.formData.i_ingsid,
                    i_inckid:this.formData.i_inckid,
                    i_squid:this.formData.i_squid,
                    vc_squname:this.formData.vc_squname,
                    vc_note:this.formData.vc_note,
                    c_type:4,
                    vc_start_add:this.formData.vc_start_add,
                    vc_start_lxr:this.formData.vc_start_lxr,
                    vc_start_lxr_tel:this.formData.vc_start_lxr_tel,
                    vc_shdd:this.formData.vc_shdd,
                    vc_sendadd_lxr:this.formData.vc_sendadd_lxr,
                    vc_sendadd_lxr_tel:this.formData.vc_sendadd_lxr_tel,
                    dt_yjdhtime:this.formData.dt_yjdhtime,
                    istran:this.formData.istran,
                    vc_thfs:this.formData.vc_sendway,
                    //新增是否化验
                    i_ischeck:this.formData.i_ischeck,
                    i_wluid:this.formData.i_wluid,
                    vc_khname:this.formData.vc_khname,
                    i_khid:this.formData.i_khid,
                    i_kpnumtype:this.formData.i_kpnumtype,
                    vc_no:this.formData.vc_no,
                    sub:this.pzlist,
                    //验证
                    //i_id:this.i_id,
                    busType:this.busType,
                    dt_createtime:this.dt_createtime,
                    //c_type:this.c_type,
                    i_sqlruid:this.i_sqlruid,
                    table:this.table,
                    validateCode:this.validateCode,
                    validateKeynames:this.validateKeynames,
                    relRecvCompany:this.formData.relRecvCompany,
                    isRelPurchase:this.formData.isRelPurchase,
                    i_pid:this.formData.i_pid,
                    //i_ywid:this.formData.i_ywid,//出入库申请主子表ID(i_ywid在子项

                };
                //console.log("param",param)
                //return;
                let res=await API.saveSqStore(param);
                if(res.code==1){
                    /*this.$message.success(res.message);
                    this.visible=false;
                    this.$emit('shuaxinboth',this.pageSize);
                    this.cancel();*/
                    this.isedit=true;
                    this.loading=false;
                    this.sqdetail(res.data);
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.dt_createtime=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .marT10{
        margin-top: 10px;
    }
    .mart3{
        margin-top: 3px;
    }
    .bor{
        border-top: 1px solid #ebeef5;
    }
    .tsc{
        text-align: left;
    }
    .w100-{
        width: calc(100% - 24px);
    }
    .w20{
        width: 20%;
    }
    .w40{
        width: 40%;
    }
    .marr3{
        margin-right: 3px;
    }
    .wid100_bz{
        width: calc(100% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    /deep/.el-input__suffix{
        right: 12px;
    }
    /deep/.nodata .el-input__inner{
        padding: 0 9px;
    }
    .wid100{
        width: 100%;
    }
    .redbtn{
        background-color: #fa5050;
        border: #fa5050;
        color: white;
    }

    .mar3{
        margin:3px 0px;
    }
    .moren .el-form-item__label{
        width:130px !important;
    }
    .inputw{
        //width:calc(100% - 90px);
    }
    .wid50{
        width: calc(50% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .mart20{
        margin-top: 20px;
    }
    .borb{
        //border-bottom: 1px solid #efefef;
        //margin-top: 1px;
    }
    .fr{
        float: right;
    }
    .wid66{
        width: calc(66% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .wid60{
        width: 60%;
    }
    .form-title{
        width: calc(33% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .flex{
        display: flex;
    }
    .b{
        justify-content: space-between;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }

    .num .el-form-item__label {
        color: #b3d268;
        font-size: 16px;
        font-style: italic;
    }
    .num .el-form-item__content {
        width: 150px;
    }
    .pop{
        .addbtn{
            border: none;
            padding: 0;
        }
    }
    /deep/.pop .el-popover{
        right: 24px !important;
        top:30px !important;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
    /deep/.guding{
        /*.el-form-item__label{
            min-width: 85px !important;
            margin-right: 3px !important;
        }*/
    }
    /deep/.table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }
        .el-form-item__label{
            text-align: left;
            color: #808080;
            min-width: 84px;
            margin-right: 9px;
            padding: 0px !important;
            font-size: 14px !important;
        }
        .el-input--mini .el-input__inner{
            height: 24px;
            line-height: 24px;
        }
        .el-form-item__content{
            width: 100% ;
        }
    }

</style>
